import { CHECK_AUTH_STATE_SUCCESS, LOGIN_SUCCESS, SUBMIT_SELECTION_SUCCESS, LOGOUT_SUCCESS } from 'client/constants';

const initialState = null;

export default function userReducer(state = initialState, { type, payload }) {
	switch (type) {
		case CHECK_AUTH_STATE_SUCCESS:
		case LOGIN_SUCCESS:
			return {
				...payload,
			};

		case SUBMIT_SELECTION_SUCCESS:
			return {
				...state,
				isSelectionSubmitted: true,
			};

		case LOGOUT_SUCCESS:
			return null;

		default:
			return state;
	}
}
